<template>
<div>
	<div class="container container--small pdt-50 pdb-50">
				<div class="t-headline11 font-m mgb-8 pdl-24 pdr-24">{{$t('1608')}}</div>
				<div class="t-body1 t-color-bodyGrayA font-r pdl-24 pdr-24">{{$t('1609')}}</div>
				<div class="pdl-24 pdr-24">
					 <!-- fsdfffffffff{{lang}} -->
					<div v-if="lang.code.toLowerCase()=='ko'||lang.code.toLowerCase()=='vi' || lang.code.toLowerCase()=='ja' || lang.code.toLowerCase()=='zh-cn' || lang.code.toLowerCase()=='zh-tw' || lang.code.toLowerCase()=='hu'">
						
						<div class="mgt-40">
							<label
								class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
								data-mdc-auto-init="MDCTextField" 
								:class="submitState && lastNameInvalidCheck ? 'mdc-text-field--invalid' : ''" id="lastNameEl">
								<span class="mdc-notched-outline">
									<span class="mdc-notched-outline__leading"></span>
									<span class="mdc-notched-outline__notch">
										<span class="mdc-floating-label" id="password-message">{{$t('1610')}}</span>
									</span>
									<span class="mdc-notched-outline__trailing"></span>
								</span>
								<input class="mdc-text-field__input" 
									id="lastName"
									name="lastName"
									v-model="lastName"                            
									v-validate="'required'"
									ref="lastName"
									maxlength="50">
								<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
									role="button">report_problem</i>
							</label>
							<div class="mdc-text-field-helper-line">
								<div class="mdc-text-field-helper-text mdc-text-field-helper-text--validation-msg t-helper font-r"
									id="my-helper-id" aria-hidden="true">{{$t('951')}}
								</div>
							</div>
						</div>

						<div class="mgt-16">
							<label
								class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
								data-mdc-auto-init="MDCTextField" 
								:class="submitState && firstNameInvalidCheck ? 'mdc-text-field--invalid' : ''"
								id="firstNameEl">
								<span class="mdc-notched-outline">
									<span class="mdc-notched-outline__leading"></span>
									<span class="mdc-notched-outline__notch">
										<span class="mdc-floating-label" id="my-label-id">{{$t('1611')}}</span>
									</span>
									<span class="mdc-notched-outline__trailing"></span>
								</span>
								<input class="mdc-text-field__input" 
									v-model="firstName"
									v-validate="'required'"
									ref="firstName"
									id="firstName"
									name="firstName"
									maxlength="50">
								<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
									role="button">report_problem</i>
							</label>
							<div class="mdc-text-field-helper-line">
								<div class="mdc-text-field-helper-text mdc-text-field-helper-text--validation-msg t-helper font-r"
									id="my-helper-id" aria-hidden="true"> {{$t('952')}}
								</div>
							</div>
						</div>
					</div>
					<div v-else>
						<div class="mgt-40">
							<label
								class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
								data-mdc-auto-init="MDCTextField" 
								:class="submitState && firstNameInvalidCheck ? 'mdc-text-field--invalid' : ''"
								id="firstNameEl">
								<span class="mdc-notched-outline">
									<span class="mdc-notched-outline__leading"></span>
									<span class="mdc-notched-outline__notch">
										<span class="mdc-floating-label" id="my-label-id">{{$t('1611')}}</span>
									</span>
									<span class="mdc-notched-outline__trailing"></span>
								</span>
								<input class="mdc-text-field__input" 
									v-model="firstName"
									v-validate="'required'"
									ref="firstName"
									id="firstName"
									name="firstName"
									maxlength="50">
								<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
									role="button">report_problem</i>
							</label>
							<div class="mdc-text-field-helper-line">
								<div class="mdc-text-field-helper-text mdc-text-field-helper-text--validation-msg t-helper font-r"
									id="my-helper-id" aria-hidden="true"> {{$t('952')}}
								</div>
							</div>
						</div>
						<div class="mgt-16">
							<label
								class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
								data-mdc-auto-init="MDCTextField" 
								:class="submitState && lastNameInvalidCheck ? 'mdc-text-field--invalid' : ''" id="lastNameEl">
								<span class="mdc-notched-outline">
									<span class="mdc-notched-outline__leading"></span>
									<span class="mdc-notched-outline__notch">
										<span class="mdc-floating-label" id="password-message">{{$t('1610')}}</span>
									</span>
									<span class="mdc-notched-outline__trailing"></span>
								</span>
								<input class="mdc-text-field__input" 
									id="lastName"
									name="lastName"
									v-model="lastName"                            
									v-validate="'required'"
									ref="lastName"
									maxlength="50">
								<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
									role="button">report_problem</i>
							</label>
							<div class="mdc-text-field-helper-line">
								<div class="mdc-text-field-helper-text mdc-text-field-helper-text--validation-msg t-helper font-r"
									id="my-helper-id" aria-hidden="true">{{$t('951')}}
								</div>
							</div>
						</div>
					</div>
					<div class="mgt-30 mgb-50">
						<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8" @click="next()" @keypress="next()" tabindex="0">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r">{{$t('1612')}}</span>
						</button>
						<button class="mdc-button t-color-secondaryBtnText b-radius4" @click="cancelJoin()" @keypress="cancelJoin()" tabindex="0">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r">{{$t('1613')}}</span>
						</button>
					</div>
				</div>
			</div>
</div>
	
</template>

<script>
/**
 * 회원가입 - 이름입력(sign up - input name component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import findApi from '@/api/findApi.js'
import {mapState, mapMutations} from 'vuex'
import {joinMixin} from '@/mixins/join.js'

export default {
	data() {
		return {
			firstName: '',
			lastName: '',
			firstNameTextField: null,
			lastNameTextField: null,
			lang :JSON.parse(localStorage.getItem('languageInfo')),
			//lang :{code:'zh-CN'},
			submitState: false
		}
	},

	mixins: [joinMixin],

	computed : {
		...mapState('join',{
			join : state => state,
		}),
	   
		// firstName 유효성 Check(validation firstName)
		firstNameInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('firstName')) {
					returnValue = true
				}else {
					returnValue = false
				}
			}
			this.firstNameTextField.valid === !returnValue ? '' : this.firstNameTextField.valid = !returnValue
			return returnValue
		},

		// lastName 유효성 Check(validation lastName)
		lastNameInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('lastName')) {
					returnValue = true
				}else {
					returnValue = false
				}
			}
			this.lastNameTextField.valid === !returnValue ? '' : this.lastNameTextField.valid = !returnValue
			return returnValue
		},
	},

	created() {
		if (!this.join.responsibility || !this.join.terms.TERMS_OF_SERVICE) {
			this.moveJoin2Intro()
		}
	},

	mounted() {
		window.mdc.autoInit();
		if(document.querySelector('.mdc-tab-bar')){
			var tabBar = new mdc.tabBar.MDCTabBar(document.querySelector('.mdc-tab-bar'));
		}
		if(document.querySelector('.mdc-text-field')){
			var textField = new MDCTextField(document.querySelector('.mdc-text-field'));
		}
		this.setMaterialUi()
		//this.$refs.firstName.focus()
		this.lang.code=='ko'|| this.lang.code=='vi' || this.lang.code=='ja' || this.lang.code=='zh-cn' || this.lang.code=='zh-tw' || this.lang.code=='hu'? this.$refs.lastName.focus():this.$refs.firstName.focus()
	},

	methods: {
		// Store 변이 정의(define store mutation)
		...mapMutations('join', ['SET_NAME_FIRST', 'SET_NAME_LAST', 'SET_NAME_FULL']),

		setMaterialUi() {
			this.firstNameTextField = new MDCTextField(document.querySelector('#firstNameEl'))
			this.firstNameTextField.useNativeValidation = false

			this.lastNameTextField = new MDCTextField(document.querySelector('#lastNameEl'))
			this.lastNameTextField.useNativeValidation = false

			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})

			this.firstName = this.join.name.first
			this.lastName = this.join.name.last
			this.firstNameTextField.value = this.firstName
			this.lastNameTextField.value = this.lastName
		},
		focusFirstInvalidElement() {
			let invalidElementName = Object.keys(this.errors.collect())[0]
			// console.log(invalidElementName);
			this.$refs[`${invalidElementName}`].focus()
		},
		next() {
			this.$validator.validateAll().then((resultValid) => {
				this.submitState = true
				if (resultValid) {
					this.SET_NAME_FIRST(this.firstName)
					this.SET_NAME_LAST(this.lastName)
					this.SET_NAME_FULL(this.firstName + ' ' + this.lastName)
					
					this.$router.push({name: 'Join2Email'})                    
				} else{
				this.focusFirstInvalidElement()
				//	this.$refs.firstName.focus()
				}
			})
		}
	},
}
</script>